import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./i18n";

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { persistor, store } from "./app/features/store";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ErrorPage from "./app/screens/ErrorPage";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Login from "./app/screens/Login";
import Patient from "./app/screens/Patient";
import Patients from "./app/screens/Patients";
import { PersistGate } from "redux-persist/integration/react";
import PrimaryAppBar from "./app/components/PrimaryAppBar";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import RequireAuth from "./app/components/RequireAuth";
import TermsOfUse from "./app/screens/TermsOfUse";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const router = createBrowserRouter([
  {
    element: <PrimaryAppBar />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        element: <RequireAuth />,
        children: [
          {
            path: "patients",
            element: <Patients />,
            children: [
              {
                path: "patient/:uid",
                element: <Patient />,
              },
            ],
          },
          {
            path: "termsOfUse",
            element: <TermsOfUse />,
          },
        ],
      },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RouterProvider router={router} />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
